import type { DeepReadonly, Ref } from 'vue';
import { inject, provide } from 'vue';

export type Step = {
  id: string;
  name: string;
};

export type MultiStepFormContext = {
  currentStep: DeepReadonly<Ref<Step>>;
  prevStep: DeepReadonly<Ref<Step | undefined>>;
  nextStep: DeepReadonly<Ref<Step | undefined>>;
  isFirstStep: DeepReadonly<Ref<boolean>>;
  isLastStep: DeepReadonly<Ref<boolean>>;
  onLast: () => void;
  onFirst: () => void;
  onNext: () => void;
  onBack: () => void;
};
const MULTI_STEP_FORM_CONTEXT_KEY = Symbol();
export const provideMultiStepFormContext = (context: MultiStepFormContext) =>
  provide(MULTI_STEP_FORM_CONTEXT_KEY, context);
export const injectMultiStepFormContext = () => {
  const context = inject<MultiStepFormContext>(MULTI_STEP_FORM_CONTEXT_KEY);

  if (context === undefined) {
    throw new Error('Context was expected from KaTableRow component but received none');
  }

  return context;
};

export const scrollHorizontalSteps = (
  index: number,
  listEl: HTMLElement | undefined,
  listItemEls: HTMLElement[] | undefined,
) => {
  if (
    listEl === undefined ||
    listItemEls === undefined ||
    listItemEls.length === 0 ||
    // No scroll - nothing to do
    listEl.scrollWidth <= listEl.offsetWidth
  )
    return;

  const chosenItem = listItemEls[index];
  if (chosenItem === undefined) return;

  const { left: listLeft, width: listWidth } = listEl.getBoundingClientRect();
  const { left: listItemLeft, width: listItemWidth } = chosenItem.getBoundingClientRect();

  const itemPositionAtLeft = listItemLeft - listLeft + listEl.scrollLeft;
  const distanceToCenter = listWidth / 2 - listItemWidth / 2;

  listEl.scrollTo({ left: itemPositionAtLeft - distanceToCenter, behavior: 'smooth' });
};
